export const kciEnTranslations = {
  // Time Filter
  timePeriod: 'Time Period',
  selectAnalysisTimeframe: 'Select the analysis timeframe',
  allTime: 'All Time',
  last12Months: 'Last 12 Months',
  last3Months: 'Last 3 Months',
  thisMonth: 'This Month',

  // Dashboard
  dashboard: 'KCI Dashboard',
  overview: 'KCI Overview',
  welcomeMessage:
    'Welcome to the KCI (Knowledge, Competency, Innovation) dashboard.',
  focusEmployee: 'Focus Employee',
  selectEmployeeToAnalyze: 'Select employees to analyze their KCI metrics',
  relatedEmployees: 'Related Employees',
  selectEmployeesToCompare: 'Select employees to compare',
  selectedTimePeriod: 'Selected time period',
  selectedEmployees: 'Selected employees',
  noEmployeesSelected: 'No employees selected',
  employeeSelected: 'employee(s) selected',
  selectedEmployeeList: 'Selected employees',

  // Score Cards
  performanceScore: 'KCI Performance Score',
  kciSubtitle: 'KCI - Key Communication Index',
  loadingKciData: 'Loading KCI data...',
  errorCalculatingScores: 'Error calculating KCI scores',
  noCommunicationData: 'No communication data found for the selected period.',
  solveScore: 'INTERA Score',
  pecTitle: 'Personal Effort Contribution',
  pecDescription: 'Measures how easy it is to collaborate with me',
  ppcTitle: 'Personal Performance Contribution',
  ppcDescription: 'Reflects my impact on the performance of others',
  pesTitle: 'Personal Engagement Score',
  pesDescription: "Indicates my level of involvement in my team's achievements",
  pvaTitle: 'Personal Value Alignment',
  pvaDescription:
    "Assesses how well I am seen as embodying the company's values",

  // PES Suggestions
  pesSuggestions: 'PES Suggestions',
  boostYourPes: 'Boost Your PES',
  noPesSuggestions: 'No PES suggestions for the current month',
  sendToYourEmployee: 'Interact with your employee',
  sendToTeammate: 'Interact with teammate',
  suggestionType: 'Suggestion Type',
  suggestionManagerNotSentEmployee:
    "Manager: Send I Need You to employees you haven't interacted with",
  suggestionEmployeeNotSentPeer:
    "Employee: Send I Need You to peers you haven't interacted with",
  sendFeedbackSuggestion: 'Send I Need You',
  sendFeedbackSuggestionDescription:
    "You haven't sent I Need You this month. Send I Need You to boost your PES score.",
  strongEngagementMessage:
    "This month you've shown strong engagement with your team.",
  connectWithColleagues:
    "Connect with colleagues you haven't reached out to yet:",
  connectionsHelpStrengthenScore:
    'These connections help strengthen your score.',
  moreSuggestions: (count: number) => `+${count} more`,

  // Scoring Scale
  scoringScaleTitle: 'KCI Scoring Scale',
  scoreHighlySupportive: 'Highly Supportive',
  scoreSupportive: 'Supportive',
  scoreNeutral: 'Neutral',
  scoreObstructive: 'Obstructive',
  scoreHighlyObstructive: 'Highly Obstructive',

  // Overview Cards
  iSeeYou: 'I See You',
  iNeedYou: 'I Need You',
  iLearn: 'I Learn',
  sent: 'Sent',
  received: 'Received',
  created: 'Created',
  participated: 'Participated',
  unresolved: 'Unresolved',
  resolved: 'Resolved',

  // Trends
  trendsTitle: 'KCI Trends',
  hidden: 'Hidden',
  monthJan: 'Jan',
  monthFeb: 'Feb',
  monthMar: 'Mar',
  monthApr: 'Apr',
  monthMay: 'May',
  monthJun: 'Jun',
  monthJul: 'Jul',
  monthAug: 'Aug',
  monthSep: 'Sep',
  monthOct: 'Oct',
  monthNov: 'Nov',
  monthDec: 'Dec',

  // Raw Data Table
  createdAt: 'Created At',
  sender: 'Sender',
  receiver: 'Receiver',
  type: 'Type',
  tags: 'Tags',
  outcomeGoal: 'Outcome/Goal',
  loadingRawData: 'Loading raw data...',
  errorLoadingRawData: 'Error loading raw data',
  noData: 'No data',
  noGoal: 'No goal specified',
  completed: 'Completed',
  pending: 'Pending',
  self: 'Self',
  filtered: 'Filtered',
  allCommunicationsTitle: 'All Communications - {{userName}}',
  filteredCommunicationsTitle:
    'Communications - {{userName}} ({{count}} filtered)',

  // Radar
  radarValue: 'Value',
  radarDescription: 'Description',
  radarAlignmentScore: 'Alignment Score',
  radarScore: 'Score',
  radar: {
    // Loading and Error States
    loadingRadarData: 'Loading radar data...',
    errorLoadingRadarData: 'Error loading radar data',
    retry: 'Retry',

    // Score Selector Options
    workOption: 'How easy is it to work with me?',
    promoteOption: 'How much to I promote my colleagues goals?',
    alignmentOption: 'My alignment to the values',

    // Time Range Select
    timeRange: 'Time Range',

    // Employee Select
    selectEmployee: 'Select an employee...',
    loadingEmployees: 'Loading employees...',
    errorLoadingEmployees: 'Error loading employees',
    noEmployeesAvailable: 'No employees available',
    focusedEmployee: 'Focused Employee',

    // Related Employees Select
    selectEmployees: 'Select employees',
    selected: 'Selected',
    relatedEmployees: 'Related Employees',
    loadingRelatedEmployees: 'Loading related employees...',
    errorLoadingRelatedEmployees: 'Error loading related employees',
    noRelatedEmployeesFound: 'No related employees found',

    // Multi Select Header
    selectOptions: 'Select options',
    allSelected: 'All selected',
    selectAll: 'Select all',
    clearAll: 'Clear all',

    // Grade Display
    personalEffortContribution: 'Personal Effort Contribution',
    personalPerformanceContribution: 'Personal Performance Contribution',
    personalValueAlignment: 'Personal Value Alignment',
    personalEngagementScore: 'Personal Engagement Score',
  },
};
